module.exports = __webpack_public_path__ + "public/images/donut.01ad6fa8ea2fcba0d2f8c7d32ab6b51e.png";